<template>
    <div>
        <div class="nav-wrap">
            <div class="container nav-content">
                <ul class="nav-menu">
                    <li>
                        <img src="../../../assets/images/web_top_logo.png" width="69"/>
                    </li>
                    <li class="nav-bar" v-for="(item,index) in navList" @click="jumpModule(index)">
                        <a :class="{'active': theNav== index}"	@click="theNav = index">{{item.name}}</a>
                    </li>
                    <li class="nav-bar">
                        <a href="news.html">News</a>
                    </li>
                </ul>
                <div class="nav-right">
                    <!--<div class="language">-->
                        <!--<el-select v-model="selectLanguage" placeholder="请选择">-->
                            <!--<el-option label="简体中文" value="0"></el-option>-->
                            <!--<el-option label="English" value="1"></el-option>-->
                        <!--</el-select>-->
                    <!--</div>-->
                    <div v-if="memberToken == null || memberToken.length == 0">
                        <a href="login.html" class="btn-login">Login</a>
                        <a href="login.html?&&2" class="btn-regist">Start Free Trial</a>
                    </div>
                    <div v-else class="inline">
                        <a href="projectList.html" class="project-list">Projects</a>
                        <a href="projectList.html" v-if="headImagePath == null || headImagePath.length == 0" class="head-img no-img">{{firstLetter}}</a>
                        <a v-else href="projectList.html"><img :src="headImagePath" class="head-img" width="60" height="60"></a>
                    </div>
                </div>
                <div class="show"><i class="el-icon-more"></i></div>
                <ul class="hide">
                    <li v-for="(item,index) in navList" @click="jumpModule(index)">
                        <a :class="{'active': theNav== index}"	@click="theNav = index">{{item.name}}</a>
                    </li>
                    <li>
                        <a href="news.html">News</a>
                    </li>
                    <li v-if="memberToken == null || memberToken.length == 0">
                        <a href="login.html" class="btn-login">Login</a>
                        <a href="login.html?&&2" class="btn-regist">Start Free Trial</a>
                    </li>
                    <li v-else class="inline">
                        <a href="projectList.html" v-if="headImagePath == null || headImagePath.length == 0" class="head-img no-img">{{firstLetter}}</a>
                        <a v-else href="projectList.html"><img :src="headImagePath" class="head-img" width="60" height="60"></a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="section-features item" id="nav0">
            <div class="features-bg">
                <div class="features-container container">
                    <div class="text">
                        <h1>Flexible access. No Installtion required.</h1>
                        <h2>What is BugX</h2>
                        <h4>A new and simple software project management tool</h4>
                        <h5>With BugX, you can accomplish all your goals. It will bring you completely new approaches to software<br />project planning, management ,execution and bug fix ,in an easy way with BugX.</h5>
                    </div>
                    <img src="../../../assets/images/web_top_pic_english.png" width="100%"/>
                </div>
            </div>
            <div class="work-container container">
                <h2>Enable easier project management</h2>
                <h3>Through the clear and elegant Kanban, you will know Who is doing What and When a task will be completed. Even a task requiring cross-team collaboration can be precisely completed.</h3>
                <div>
                    <img src="../../../assets/images/web_pic_feature1.png" width="100%">
                </div>
                <h3>Record every critical detail and all operations to resolve each problem</h3>
                <div>
                    <img src="../../../assets/images/web_pic_feature2.png" width="100%">
                </div>
            </div>
        </div>
        <div class="section-price item" id="nav1">
            <h2>Try BugX, free for 14 days</h2>
            <h3>No credit card needed upfront. Simply choose a plan when you’re ready. <br />Have a larger team?  <a class="text-blue" @click="contact">Contact us</a></h3>
            <div class="price-bg">
                <ul class="price-sort">
                    <li v-for="(product,index) in productList">
                        <div class="price-wrap">
                            <div class="price-tab">
                                <img v-if="index % 5 == 0" src="../../../assets/images/web_price_free.png" height="60">
                                <img v-if="index % 5 == 1" src="../../../assets/images/web_price_standard.png" height="60">
                                <img v-if="index % 5 == 2" src="../../../assets/images/web_price_pro.png" height="60">
                                <img v-if="index % 5 == 3" src="../../../assets/images/web_price_premium.png" height="60">
                                <img v-if="index % 5 == 4" src="../../../assets/images/web_price_deluxe.png" height="60">
                                <div :class="{'bg1': index % 5 == 0, 'bg2': index % 5 == 1, 'bg3': index % 5 == 2, 'bg4': index % 5 == 3, 'bg5': index % 5 == 4}">
                                    <div class="text1">{{product.theName | valNullHandler}}</div>
                                </div>
                                <span class="text2">$</span>
                                <span class="text3">{{product.money | valNullHandler}}</span>
                                <span class="text4" v-if="product.durationType == 1">/{{product.duration | durationTypeHandler($store.state.i18n.packageDay[1],$store.state.i18n.packageDays[1])}}</span>
                                <span class="text4" v-else-if="product.durationType == 2">/{{product.duration | durationTypeHandler($store.state.i18n.packageMonth[1],$store.state.i18n.packageMonths[1])}}</span>
                                <span class="text4" v-else-if="product.durationType == 3">/{{product.duration | durationTypeHandler($store.state.i18n.packageYear[1],$store.state.i18n.packageYears[1])}}</span>
                                <span class="text5">{{product.memberCount | durationTypeHandler($store.state.i18n.packageMember[1],$store.state.i18n.packageMembers[1])}}</span>
                            </div>
                            <div class="detail-tab">
                                <div class="detail-text">
                                    <img src="../../../assets/images/web_price_check.png" width="18">
                                    <span class="num">{{product.projectCount | valNumberNullHandler($store.state.i18n.packageUnlimited[1])}}</span>
                                    <span class="info">{{product.projectCount | durationTypeWithoutValHandler($store.state.i18n.packageProject[1],$store.state.i18n.packageProjects[1])}}</span>
                                </div>
                                <div class="detail-text">
                                    <img src="../../../assets/images/web_price_check.png" width="18">
                                    <span class="num">{{product.bugCount | valNumberNullHandler($store.state.i18n.packageUnlimited[1])}}</span>
                                    <span class="info">{{product.bugCount | durationTypeWithoutValHandler($store.state.i18n.packageBug[1],$store.state.i18n.packageBugs[1])}}</span>
                                </div>
                                <div class="detail-text">
                                    <img src="../../../assets/images/web_price_check.png" width="18">
                                    <span class="num">{{product.missionCount | valNumberNullHandler($store.state.i18n.packageUnlimited[1])}}</span>
                                    <span class="info">{{product.missionCount | durationTypeWithoutValHandler($store.state.i18n.packageTask[1],$store.state.i18n.packageTasks[1])}}</span>
                                </div>
                                <div class="detail-text">
                                    <img src="../../../assets/images/web_price_check.png" width="18">
                                    <span class="num">{{product.testUseCaseCount | valNumberNullHandler($store.state.i18n.packageUnlimited[1])}}</span>
                                    <span class="info">{{product.testUseCaseCount | durationTypeWithoutValHandler($store.state.i18n.packageTestCase[1],$store.state.i18n.packageTestCases[1])}}</span>
                                </div>
                                <div class="detail-text">
                                    <img src="../../../assets/images/web_price_check.png" width="18">
                                    <span class="num">{{product.emailCount | valNumberNullHandler($store.state.i18n.packageUnlimited[1])}}</span>
                                    <span class="info">{{product.emailCount | durationTypeWithoutValHandler($store.state.i18n.packageEmailNotification[1],$store.state.i18n.packageEmailNotifications[1])}}</span>
                                </div>
                                <div class="detail-text" style="white-space: nowrap">
                                    <img src="../../../assets/images/web_price_check.png" width="18">
                                    <span class="num">{{product.storageSpace | valNumberNullHandler($store.state.i18n.packageUnlimited[1])}}</span>
                                    <span class="info">MB Storage</span>
                                </div>
                            </div>
                            <div v-if="product.money == 0" @click="jumpToPayPage(1, product, index)" :class="{'tab-btn btn1': index % 5 == 0, 'tab-btn btn2': index % 5 == 1, 'tab-btn btn3': index % 5 == 2, 'tab-btn btn4': index % 5 == 3, 'tab-btn btn5': index % 5 == 4}">
                                <span>Sign Up Now</span>
                            </div>
                            <div v-else @click="jumpToPayPage(2,product, index)" :class="{'tab-btn btn1': index % 5 == 0, 'tab-btn btn2': index % 5 == 1, 'tab-btn btn3': index % 5 == 2, 'tab-btn btn4': index % 5 == 3, 'tab-btn btn5': index % 5 == 4}">
                                <span>Get Started</span>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="tip-text">All prices shown are US dollars</div>
            </div>
        </div>
        <div class="section-question" id="question" style="display: none;">
            <div class="container">
                <h2>Questions & Answers</h2>
                <div class="cs-collapse">
                    <el-collapse v-model="activeNames" @change="handleChange">
                        <el-collapse-item title="一致性 Consistency" name="1">
                            <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
                            <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>
                        </el-collapse-item>
                        <el-collapse-item title="反馈 Feedback" name="2">
                            <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
                            <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
                        </el-collapse-item>
                        <el-collapse-item title="效率 Efficiency" name="3">
                            <div>简化流程：设计简洁直观的操作流程；</div>
                            <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
                            <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
                        </el-collapse-item>
                        <el-collapse-item title="可控 Controllability" name="4">
                            <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
                            <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
        <!--<div class="section-customer" id="customers" style="display: none;">
            <div class="container">
                <h2>BugX customers</h2>
                <div class="cs-customer">
                    <img src="https://www.chisalsoft.co/upFile/Partner/CS/2019/9/20190905110850-Nq42RADi-home_logo_philips.png" width="180">
                    <img src="https://www.chisalsoft.co/upFile/Partner/CS/2019/9/20190905110850-Nq42RADi-home_logo_philips.png" width="180">
                    <img src="https://www.chisalsoft.co/upFile/Partner/CS/2019/9/20190905110850-Nq42RADi-home_logo_philips.png" width="180">
                    <img src="https://www.chisalsoft.co/upFile/Partner/CS/2019/9/20190905110850-Nq42RADi-home_logo_philips.png" width="180">
                    <img src="https://www.chisalsoft.co/upFile/Partner/CS/2019/9/20190905110850-Nq42RADi-home_logo_philips.png" width="180">
                    <img src="https://www.chisalsoft.co/upFile/Partner/CS/2019/9/20190905110850-Nq42RADi-home_logo_philips.png" width="180">
                </div>
            </div>
        </div>-->
        <div class="section-contact item" id="nav2">
            <div class="container">
                <h2>Contact us</h2>
                <h3>You can find us here</h3>
                <div class="contact-info">
                    <div class="text-info">
                        <img src="../../../assets/images/web_contact_location.png" width="36">
                        <div class="right">
                            <div class="title">Location:</div>
                            <div class="text">Room B501, Building 16, No.328 Xinghu Street, <br/>Suzhou Industrial Park, Suzhou 215123, P.R.China</div>
                        </div>
                    </div>
                    <div class="text-info">
                        <img src="../../../assets/images/web_contact_whatsapp.png" width="36">
                        <div class="right">
                            <div class="title">WhatsApp:</div>
                            <div class="text">+86 186 6218 1199</div>
                        </div>
                    </div>
                    <div class="text-info">
                        <img src="../../../assets/images/web_contact_email.png" width="36">
                        <div class="right">
                            <div class="title">Email:</div>
                            <a class="text email" href="mailto:ahsun.Chen@chisalsoft.com?subject=Bugx咨询">ahsun.chen@chisalsoft.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-buy">
            <div class="text">Are you ready to try bugx now?</div>
            <div onclick="window.location.href='login.html?&&2'" class="btn-free">Start Free Trial</div>
        </div>
        <div class="section-foot">
            <div class="container">
                <div class="foot-logo">
                    <img src="../../../assets/images/web_bottom_logo.png" width="80">
                </div>
                <ul class="foot-link">
                    <li v-for="(item,index) in navList" @click="jumpModule(index)">
                        <a @click="theNav = index">{{item.name}}</a>
                    </li>
                </ul>
                <ul class="foot-link">
                    <li>
                        <a href="https://www.chisalsoft.com.cn/" target="_blank">Chisalsoft</a>
                    </li>
                    <li>
                        <a href="https://www.chisalsoft.com.cn/ITService" target="_blank">Technical service</a>
                    </li>
                    <li>
                        <a href="https://www.chisalsoft.com.cn/CaseIntroduce" target="_blank">Cases</a>
                    </li>
                    <li>
                        <a href="https://www.chisalsoft.com.cn/News" target="_blank">Blog</a>
                    </li>
                </ul>
                <ul class="foot-link">
                    <li>
                        <a href="http://chisalcar.com" target="_blank">Suncar APP</a>
                    </li>
                    <li>
                        <a href="https://sj.qq.com/myapp/detail.htm?apkName=com.chisal.app_dev&apkCode=298" target="_blank">APP Development</a>
                    </li>
                    <!--<li>
                        <a href="https://www.chisalsoft.com.cn/CaseDetailWovo" target="_blank">WUVO</a>
                    </li>-->
                    <li>
                        <a href="http://mars.marsdriving.com/" target="_blank">MARS</a>
                    </li>
                </ul>
                <div class="facebook">
                    <img src="../../../assets/images/web_link_facebook.png" width="36" class="img-unsel">
                    <img src="../../../assets/images/web_link_facebook_check.png" width="36" class="img-sel">
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <div class="foot-text">©2013-<span id="myYear"></span> Suzhou ChisalSoft Technology Co., Ltd. <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备 13060847号-3</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002004321">
            <img src="https://chisal-officialwebsite-sh-release.chisalsoft.co/备案图标.png" style="width: 20px;position: relative;top: -2px;margin: 0 0 0 5px;">
            苏公网安备 32059002004321号
          </a>
        </div>
    </div>
</template>
<script>
	import Vue from 'vue'
    import $ from 'jquery'
    import VueCookies from 'vue-cookies'
    import {Select, Option,Collapse,CollapseItem,Message} from 'element-ui';
    import GlobalData from "../../../assets/js/common/GlobalData";
    //Cookie
    Vue.use(VueCookies)
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(Collapse);
    Vue.use(CollapseItem);
    Vue.prototype.$message = Message;

    export default {
        name: "index",
        data() {
            return {
                interfaceVersion:19000101,
                productList:[],

                selectLanguage:'1',
                activeNames: ['1'],
                theNav:0,
                navList:[{name:'Features'},{name:'Pricing'},{name:'Contact us'}],
                //存储在本地的用户登录信息
                memberToken:null,
                headImagePath:null,
                firstLetter:null,

                navIndex:0,
            }
        },
        mounted(){
            document.getElementById("myYear").innerHTML=new Date().getFullYear();

            //动态获取路径中的参数
            this.$byUrlInitValue("&", this, ["navIndex"]);
            this.jumpModule((this.navIndex == null || this.navIndex == undefined || this.navIndex == 'null' || this.navIndex == 'undefined' || this.navIndex == '') ? 0 : this.navIndex)

            //从Cookie中获取信息
            // this.memberName = localStorage.getItem("memberName");
            this.headImagePath = localStorage.getItem("headImagePath");
            this.firstLetter = localStorage.getItem("firstLetter");
            this.memberToken = localStorage.getItem("memberToken")

            $(".hide").css('display','none');
            $(".show").click(function(){
                $(".hide").toggle(500);
            });
            $(".hide a").click(function(){
                $(".hide").hide(500);
            });

            this.itemCnt = $('.item').length
            window.addEventListener("scroll",this.handleScroll);

            //加载套餐列表
            this.getProductList()
        },
        destroyed() {
            document.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            handleChange(val) {
                console.log(val);
            },
            handleScroll() {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollTop == 0){
                    this.theNav = 0;
                }
            },
            jumpModule: function (index) {
                this.theNav = index;
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (index == 0) {
                    window.scroll(0, 0);
                } else {
                    let sum = 0;
                    for (let i = 0; i < index; i++) {
                        sum = sum + $('#nav' + i).outerHeight();
                        window.scroll(0, sum);
                    }
                    console.log(sum)
                }
            },
            contact:function(){
                window.scroll(0, 2758);
            },
            getSearchForm:getSearchForm,
            getProductList:getProductList,
            jumpToPayPage:jumpToPayPage,
        },
    }

    function getSearchForm() {
        return {
            interfaceVersion:this.interfaceVersion,
            pageNumber:1,
            countPerPage:5,
        }
    }

    function getProductList() {
        this.$api.post('/ProductListForIndex.html', this.getSearchForm(), jsonObj => {
            console.info(jsonObj);
            this.productList = jsonObj.productList
        }, jsonObj => {
            // console.log(jsonObj);
            this.$message.error(jsonObj.info);
        })
    }

    function jumpToPayPage(needbuy,product,index) {
        if(needbuy == 1)
        {
            //不需要购买，直接跳转到注册页面，新注册的账号，赠送“14天”体验
            window.location.href=`login.html?&&2`
        }
        else if(needbuy == 2)
        {
            window.location.href=`payment.html?${product.tableId}&${index}`
        }
    }
</script>
<style scoped>
    .container{
        max-width: 1100px;
        margin: 0 auto;
        padding: 0 20px;
        box-sizing: border-box;
    }
    ul,li{
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .head-img{
        width: 34px;
        height: 34px;
        line-height: 34px;
        border-radius: 50%;
        border: 1px solid transparent;
        text-align: center;
        display: inline-block;
        text-decoration: none;
    }
    .head-img:hover{
        border: 1px solid #fff;
        box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2);
    }
    .no-img{
        background: #176ad5;
        color: #fff;
    }
    .project-list{
        font-size: 16px;
        font-weight: 900;
        color: #0e3458;
        text-decoration: none;
        margin-right: 25px;
    }
    .nav-wrap{
        position: absolute;
        left: 0px;
        top: 0px;
        right: 0px;
        background-color: transparent;
    }
    .nav-content{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .nav-right{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .nav-menu li{
        display: inline-block;
        font-size: 14px;
        margin: 23px;
        vertical-align: middle;
    }
    .nav-menu li a{
        text-decoration: none;
        color: #0e3458;
        border-bottom: 2px solid transparent;
        padding-bottom: 7px;
        cursor: pointer;
    }
    .nav-menu li a.active{
        color: #176ad5;
        font-weight: 900;
        border-bottom: 2px solid #176ad5;
    }
    .language{
        width: 100px;
        display: inline-block;
    }
    .btn-login{
        padding-left: 30px;
        font-weight: 900;
        cursor: pointer;
        text-decoration: none;
        color: #222222;
    }
    .btn-regist{
        margin-left: 30px;
        padding: 13px 24px;
        border-radius: 6px;
        background-color: #136ee3;
        color: #fff;
        cursor: pointer;
        text-decoration: none;
    }
    .show{
        display: none;
        cursor: pointer;
    }
    .hide{
        display: none;
        position: absolute;
        top: 90px;
        background: #c0ddf9;
        z-index: 15;
        width: 100%;
        left: 0;
        text-align: center;
    }
    .hide .head-img{
        width: 34px;
        height: 34px;
        line-height: 34px;
        color: #fff;
        border-radius: 50%;
        border: 1px solid transparent;
        text-align: center;
        display: inline-block;
    }
    .hide li{
        width: 90%;
        margin: 10px auto;
    }
    .hide a{
        display: inline-block;
        margin: 0 auto;
        font-size: 16px;
        text-align: center;
        padding: 10px 10px;
        color: #383838;
        cursor: pointer;
        text-decoration: none;
    }
    .hide .active{
        color: #176ad5;
        font-weight: 900;
        border-bottom: 2px solid #176ad5;
    }
    .hide .btn-login{
        display: block;
        margin: 10px 0;
    }
    .hide .btn-regist{
        color: #fff;
        margin: 10px 0;
    }
    @media screen and (max-width: 800px){
        .show{
            display: inline-block;
            float: right;
        }
        .nav-menu .nav-bar{
            display: none;
        }
        .nav-right{
            display: none;
        }
    }
    @media screen and (min-width: 800px){
        .hide {
            display: none!important;
        }
    }
    /*内容区域--顶部*/
    .features-bg{
        text-align: center;
        height: 760px;
        background: url("../../../assets/images/web_top_bg.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .features-container{
        position: relative;
        top: 100px;
        padding-top: 60px;
        text-align: center;
    }
    .features-container h1{
        margin-top: 0px;
        margin-bottom: 10px;
        font-family: Avenir, sans-serif;
        color: #001b2a;
        font-size: 40px;
        line-height: 50px;
        font-weight: 900;
    }
    .features-container h2{
        margin-top: 20px;
        margin-bottom: 10px;
        font-family: Avenir, sans-serif;
        color: #33414d;
        font-size: 28px;
        line-height: 36px;
        font-weight: 900;
    }
    .features-container h4{
        font-family: Avenir, sans-serif;
        color: #385a76;
        font-size: 22px;
        font-weight: 900;
        margin: 10px 0 20px 0;
    }
    .features-container h5{
        font-family: Avenir, sans-serif;
        color: #385a76;
        font-size: 20px;
        line-height: 1.4;
        font-weight: normal;
        margin: 0;
    }
    .features-container .text{
        position: relative;
        z-index: 10;
    }
    .features-container img{
        margin-top: -60px;
    }
    .work-container h2,.section-price h2,.section-question h2,.section-customer h2,.section-contact h2{
        color: #001b2a;
        margin-top: 20px;
        margin-bottom: 10px;
        font-family: Avenir, sans-serif;
        font-size: 32px;
        font-weight: 900;
        text-align: center;
    }
    .work-container h3,.section-price h3,.section-contact h3{
        margin-top: 20px;
        margin-bottom: 40px;
        font-size: 23px;
        line-height: 1.5;
        font-weight: 400;
        color: #29475f;
        text-align: center;
    }
    /*内容区域--价格*/
    .section-price h2{
        margin-top: 50px;
    }
    .section-price .text-blue{
        color: #136ee3;
        text-decoration: none;
        cursor: pointer;
    }
    .price-sort{
        font-size: 0;
        text-align: center;
        width: 95%;
        margin-right: auto;
        margin-left: auto;
    }
    .price-bg{
        background-image: linear-gradient(rgba(255,255,255,0.1), rgba(243,238,255,0.1),rgba(63,163,255,0.1));
    }
    .price-sort li{
        display: inline-block;
        width: 20%;
        max-width: 340px;
        padding: 0 10px;
        box-sizing: border-box;
    }
    @media (max-width: 1100px){
        .price-sort li {
            width: 38%;
            max-width: 100%;
            margin: 0 auto 20px;
        }
    }
    .price-wrap{
        min-height: 635px;
        background-color: #fff;
        border-radius:10px;
        box-shadow: 0px 0px 18px 0px rgba(75, 75, 75, 0.1);
        padding-top: 35px;
        padding-bottom: 25px;
        box-sizing: border-box;
    }
    .price-sort li{
        position: relative;
        transition: all .5s ease-in-out;
        bottom: 0px;
        vertical-align: top;
    }
    .price-sort li:hover{
        bottom: 8px;
    }
    .price-sort li:hover .price-wrap{
        border: 1px solid #bea2f2;
        box-shadow: 0px 0px 18px 0px rgba(225, 232, 244, 1);
    }
    .price-text{
        font-size: 26px;
        color: #1f3d55;
        font-weight: 900;
    }
    .price-tab .text1{
        color: #1f3d55;
        font-size: 26px;
        font-weight: 900;
    }
    .price-tab .text2{
        color: #1f3d55;
        font-size: 22px;
        vertical-align: top;
        margin-right: 5px;
    }
    .price-tab .text3{
        color: #1f3d55;
        font-size: 42px;
    }
    .price-tab .text4{
        display: block;
        color: #999999;
        font-size: 14px;
        margin-top: 5px;
        margin-bottom: 20px;
    }
    .price-tab .text5{
        display: block;
        color: #666666;
        font-size: 20px;
    }
    .detail-text{
        margin: 15px 10px;
    }
    img{
        vertical-align: middle;
    }
    .detail-text .num{
        font-size: 15px;
        font-weight: 900;
        color: #1f3d55;
        margin: 0 10px 0 15px;
        vertical-align: middle;
    }
    .detail-text .info{
        font-size: 15px;
        color: #666666;
        vertical-align: middle;
    }
    .no-margin{
        margin-right: 0;
    }
    .text-tip{
        color: #1f3d55;
        font-size: 14px;
        padding-left: 25px;
    }
    .text-bold{
        font-weight: 900;
    }
    .detail-tab{
        text-align: left;
        border-top: 2px solid #f4f4f4;
        border-bottom: 2px solid #f4f4f4;
        margin: 25px 25px 0 25px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .tab-btn{
        width: 80%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-radius: 10px;
        font-size: 18px;
        cursor: pointer;
        color: #fff;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
    }
    .tab-btn.btn1{
        background-color: #626675;
    }
    .tab-btn.btn2{
        background-color: #0d8de9;
    }
    .tab-btn.btn3{
        background-color: #38ba72;
    }
    .tab-btn.btn4{
        background-color: #884be6;
    }
    .tab-btn.btn5{
        background-color: #fc504e;
    }
    .bg1{
        height: 105px;
        line-height: 105px;
        background: url("../../../assets/images/web_price_free_bg.png") no-repeat;
        background-size: 100% 100%;
    }
    .bg2{
        height: 105px;
        line-height: 105px;
        background: url("../../../assets/images/web_price_standard_bg.png") no-repeat;
        background-size: 100% 100%;
    }
    .bg3{
        height: 105px;
        line-height: 105px;
        background: url("../../../assets/images/web_price_pro_bg.png") no-repeat;
        background-size: 100% 100%;
    }
    .bg4{
        height: 105px;
        line-height: 105px;
        background: url("../../../assets/images/web_price_premium_bg.png") no-repeat;
        background-size: 100% 100%;
    }
    .bg5{
        height: 105px;
        line-height: 105px;
        background: url("../../../assets/images/web_price_deluxe_bg.png") no-repeat;
        background-size: 100% 100%;
    }
    .tip-text{
        color: #66849d;
        font-size: 18px;
        font-style:italic;
        padding: 45px 0;
        text-align: center;
    }
    /*内容区域--问题*/
    .section-question h2{
        margin: 50px 0 40px 0;
    }
    /*客户*/
    .section-customer h2{
        margin: 50px 0 40px 0;
    }
    .cs-customer img{
        background: #0a81de;
        margin: 5px;
    }
    /*联系我们*/
    .section-contact h2{
        margin-top: 50px;
    }
    .section-contact{
        text-align: center;
        padding-bottom: 90px;
    }
    .text-info{
        display: inline-block;
        margin: 10px 0;
    }
    .text-info img{
        vertical-align: middle;
    }
    .text-info .right{
        display: inline-block;
        vertical-align: middle;
        margin-left: 30px;
        margin-right: 70px;
    }
    .text-info .title{
        font-size: 18px;
        font-weight: 900;
        color: #001b2a;
        text-align: left;
        margin-bottom: 10px;
    }
    .text-info .text{
        font-size: 14px;
        color: #29475f;
        line-height: 1.6;
        text-align: left;
    }
    .text-info .email{
        color: #136ee3;
    }
    .section-buy{
        text-align: center;
        background: url("../../../assets/images/web_try_bg.png") no-repeat center/cover;
        padding: 85px 0;
    }
    .section-buy .text{
        font-size: 32px;
        font-weight: 900;
        color: #001b2a;
        margin-right: 35px;
        display: inline-block;
        vertical-align: middle;
    }
    .section-buy .btn-free{
        display: inline-block;
        vertical-align: middle;
        width: 216px;
        height: 60px;
        line-height: 60px;
        background-color: #136ee3;
        border-radius: 10px;
        font-size: 18px;
        font-weight: 900;
        color: #ffffff;
        cursor: pointer;
    }
    @media (max-width: 1100px){
        .contact-info{
            text-align: left;
            width: 60%;
            margin-left: auto;
            margin-right: auto;
        }
        .text-info{
            display: block;
        }
    }
    /*底部*/
    .section-foot{
        padding: 40px 0;
    }
    .foot-link{
        display: inline-block;
        vertical-align: top;
        width: 20%;
    }
    .foot-logo{
        display: inline-block;
        width: 20%;
    }
    .foot-link a{
        display: inline-block;
        text-decoration: none;
        font-size: 13px;
        color: #29475f;
        margin: 6px 0;
        cursor: pointer;
    }
    .facebook{
        float: right;
        padding-top: 35px;
        cursor: pointer;
    }
    .img-sel{
        display: none;
    }
    .facebook:hover .img-unsel{
        display: none;
    }
    .facebook:hover .img-sel{
        display: inline-block;
    }
    clearfix:after{
        content: '';
        display: block;
        clear: both;
    }
    .foot-text{
        background: #052a3e;
        padding: 20px 0;
        color: #fff;
        text-align: center;
    }
    .foot-text a{
        color: #fff;
        text-decoration: none;
    }
</style>
<style>
    body,html{
        padding: 0;
        margin: 0;
        height: 100%;
        font-family: Avenir, sans-serif;
        font-size: 14px;
        background: #fff;
    }
    .language input{
        background: transparent;
        color: #333;
        border: none;
    }
    .language .el-select .el-input .el-select__caret{
        color: #000;
    }
    @media screen and (max-width: 800px){
        body,html{
            min-width: 800px;
        }
    }
    .el-icon-more{
        color: #fff;
        font-size: 30px;
    }
</style>
